export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6570.1c072354.jpg";